module.exports = __webpack_public_path__ + "assets/img/DS-room3 (3).a7242192.jpg";